module.exports = __webpack_public_path__ + "static/media/IPSTLogo.f3e4df6f.svg";